import { ref, Ref } from 'vue';
import { IncidenciaService } from '@/services/IncidenciaService';

const openIncidenciasCount: Ref<number> = ref(0);
let pollingInterval: number | null = null;

export function useOpenIncidencias() {
  const fetchOpenIncidencias = async () => {
    try {
      const response = await IncidenciaService.getMisIncidenciasResponsable();
      openIncidenciasCount.value = response?.length || 0;
    } catch (error) {
      console.error('Error fetching open incidencias:', error);
      openIncidenciasCount.value = 0;
    }
  };

  const startPolling = (interval = 60000) => {
    fetchOpenIncidencias();
    if (!pollingInterval) {
      pollingInterval = window.setInterval(fetchOpenIncidencias, interval);
    }
  };

  const stopPolling = () => {
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
    }
  };

  return {
    openIncidenciasCount,
    startPolling,
    stopPolling,
    fetchOpenIncidencias
  };
}
